var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ContactButton"},[_c('div',{staticClass:"ContactButton--text"},[_vm._v("Contact")]),_c('div',{staticClass:"ContactButton--vector"},[_c('Vector',{attrs:{"svg":_vm.icon.mail}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }